import { Instance } from "mobx-state-tree"
import { PlayerStatBiggestWinModelBase } from "./PlayerStatBiggestWinModel.base"

/* The TypeScript type of an instance of PlayerStatBiggestWinModel */
export interface PlayerStatBiggestWinModelType extends Instance<typeof PlayerStatBiggestWinModel.Type> {}

/* A graphql query fragment builders for PlayerStatBiggestWinModel */
export { selectFromPlayerStatBiggestWin, playerStatBiggestWinModelPrimitives, PlayerStatBiggestWinModelSelector } from "./PlayerStatBiggestWinModel.base"

/**
 * PlayerStatBiggestWinModel
 */
export const PlayerStatBiggestWinModel = PlayerStatBiggestWinModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
